import { useEffect, useRef, useState } from "react";
import type { MutableRefObject } from "react";

type UseCopyMinHeightResult = {
  copyMinHeight: number | undefined;
  copyMeasureRefs: MutableRefObject<Array<HTMLDivElement | null>>;
};

export const useCopyMinHeight = (slidesCount: number): UseCopyMinHeightResult => {
  const [copyMinHeight, setCopyMinHeight] = useState<number | undefined>(undefined);
  const copyMeasureRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    if (!slidesCount) return;

    const updateCopyMinHeight = () => {
      const nextMinHeight = copyMeasureRefs.current.reduce((maxHeight, node) => {
        if (!node) return maxHeight;
        return Math.max(maxHeight, node.offsetHeight);
      }, 0);

      setCopyMinHeight(nextMinHeight || undefined);
    };

    const frameId = window.requestAnimationFrame(updateCopyMinHeight);
    window.addEventListener("resize", updateCopyMinHeight);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener("resize", updateCopyMinHeight);
    };
  }, [slidesCount]);

  return { copyMinHeight, copyMeasureRefs };
};
